<template>
  <div class="view-workspacemodel">
    <!-- BREADCRUMPS -->
    <div class="breadcrump-trail view-workspacemodel__breadcrumps">
      <router-link
        class="breadcrump-trail__item"
        :to="{ name: 'shared-models' }"
      >
        <lucide-icon name="chevron-left" class="breadcrump-trail__arrow" />
        {{ $t("labels.sharedModels") }}
      </router-link>
    </div>

    <p v-if="isLoading">...</p>
    <model-detail
      v-else
      :model="sharedModel ?? null"
      :editor-route="{
        name: 'shared-model',
        params: {
          modelId: sharedModel?.id
        }
      }"
    >
      <template #main>
        <h4 class="mb-2">{{ $t("labels.author") }}</h4>
        <span>{{ sharedModel?.author }}</span>
      </template>

      <template #buttons>
        <button
          v-if="sharedModel?.archived"
          type="button"
          class="button button_secondary model-detail__button"
          @click="unArchiveSharedModel(sharedModel.id)"
        >
          {{ $t("actions.restore") }}
        </button>
        <button
          v-else-if="sharedModel"
          type="button"
          class="button button_secondary model-detail__button"
          @click="archiveSharedModel(sharedModel?.id)"
        >
          {{ $t("actions.archive") }}
        </button>
      </template>
    </model-detail>
  </div>
</template>

<script setup lang="ts">
import LucideIcon from "@core/ui/LucideIcon.vue";
import ModelDetail from "@manager/workspacemodels/ModelDetail.vue";

import { useSharedModels } from "@/api/sharedModels.store";

interface Props {
  shareId: number;
}
const props = defineProps<Props>();

const { sharedModel, isLoading, archiveSharedModel, unArchiveSharedModel } =
  useSharedModels(props);
</script>

<style>
.view-sharedmodel {
  width: 100%;
  max-width: 60rem;
  margin: 0 auto;
}
</style>
